import { createApp } from "vue";
import App from "./App.vue";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import "animate.css";
import router from "./router";
import pinia from "./stores";

createApp(App).use(router).use(pinia).use(ElementPlus).mount("#app");
